/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */
/* eslint max-len:0 */

import { toMessages } from 'config/messages';

export default toMessages('ProblemErnie', {
  Message: 'There\'s been a problem. Contact Customer Support at 888.248.9190 or {link} for assistance.',
  MessageWithoutPhoneNumber: 'There\'s been a problem. Contact Customer Support at {link} for assistance.'
});
